import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart as addToNopCommerceCart, updateTempCart, updateTempCartKitUI } from "../../Store/Cart/Actions";
import { goNext, onFinish, goPrev } from "../../Store/Wizard/Actions";

class KitAccessories extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            kitAttributes: {}
        };

        this.addToCart = this.addToCart.bind(this);
        this.boxChecked = this.boxChecked.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { tempCart } = this.props;
        const { tempCart: nextTempCart } = nextProps;

        if (!_.isEqual(tempCart, nextTempCart)) {
            this.updateCheckboxes(nextTempCart);
        }
    }

    componentDidMount() {
        const { wizards, tempCart } = this.props;

        this.updateCheckboxes(tempCart);

        // hide the wireless plan message if on wizard
        $(".wireless-plan-message").hide();
        // enable to add to cart buttons on last step as these items are not required
        if (wizards.KitsBuild.currentStep === 4) {
            $("#nextButton, #topNextButton").removeClass("disabled");
        }
    }

    addToCart() {
        const { getXsrfToken, product, wizards, goNext, onFinish, addToNopCommerceCart, updateTempCart, wizard, filter: title, kitQuantity } = this.props;
        const { optionClicked } = this.state;

        if (wizard && kitQuantity === 0 || !wizard && quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {

            if (wizard) {
                updateTempCart({ [title]: { [product.id]: { ...product, quantity: kitQuantity, ...optionClicked } } });

                const { totalSteps, currentStep } = wizards.KitsBuild;

                // Wizard is finished at the second to last step because the last step is the Cart
                if (currentStep === totalSteps - 1) {
                    onFinish("KitsBuild");
                } else {
                    goNext("KitsBuild");
                }

                window.scrollTo(0, 0);
            } else {
                getXsrfToken(({ token }) => {
                    const item = {
                        ProductId: product.id,
                        Quantity: quantity
                    };

                    if (optionClicked.productAttributeId) {
                        item.AttributeControlIds = [`product_attribute_${product.id}_${optionClicked.productAttributeId}_${optionClicked.productAttributeMapId}_${optionClicked.attributeValueId}`];
                    }

                    addToNopCommerceCart({
                        items: [item],
                        __RequestVerificationToken: token
                    });
                });
            }
        }
    }

    // When checking and unchecking boxes for accessories in the build kit
    // There is a actual temp cart which adds the products to cart at end of wizard
    // There is a also a UI temp cart that uses the those items for displaying and updating the UI when checking and unchecking boxes to see changes
    boxChecked(parentProduct, products, parentId) {
        const { kitQuantity, tempCartKitUI, updateTempCart, updateTempCartKitUI, filter } = this.props;
        const $element = $(`#checkbox-${parentProduct.id}`);

        if ($element.hasClass("active")) {
            $element.removeClass("active");

            // removing all items associated to parent item for UI
            const newKitTempCart = {};

            _.each(tempCartKitUI, (category, name) => {
                const cat = {};

                _.each(category, (product, productId) => {
                    // if this is NOT the product we want to delete
                    // AND this product has only one Parent Product and the Parent Product is NOT the product we want to delete
                    // >> Add this product to the cart
                    if (parseInt(productId) !== parentId && (!product.parentProductIds || product.parentProductIds.length === 1) && parseInt(product.parentProductId) !== parentId) {
                        cat[productId] = { ...product, quantity: (product.dummyQuantity || 1) * kitQuantity };
                    }
                    // if this is NOT the product we want to delete
                    // AND this product has more than one Parent Products
                    // >> Continue evaluating
                    else if (parseInt(productId) !== parentId && (product.parentProductIds && product.parentProductIds.length > 1)) {
                        // if one of the Parent Products is the product we want to delete
                        // >> Update the quantity of this product and add it to the cart
                        if (product.parentProductIds.includes(parentId)) {
                            cat[productId] = { ...product, quantity: product.quantity - kitQuantity, dummyQuantity: product.dummyQuantity - 1 };
                        }
                        // if the product we want to delete is not onw of the Parent Products
                        // >> Add this product to the cart
                        else {
                            cat[productId] = { ...product, quantity: (product.dummyQuantity || 1) * kitQuantity };
                        }
                    }
                });

                if (Object.keys(cat).length > 0) {
                    newKitTempCart[name] = cat;
                }
            });

            // clear out the UI temp cart to update with the new temp cart created, used for when un-checking a box to remove an array of items
            updateTempCartKitUI();

            _.each(newKitTempCart, (cartItem, category) => {
                const obj = {};
                obj[category] = cartItem;

                updateTempCartKitUI(obj);
            });


            // actual temp cart remove update for unchecking a box
            const newTempCart = {};
            _.each(tempCartKitUI, (category, name) => {
                const cat = {};

                _.each(category, (product, productId) => {
                    if (parseInt(productId) !== parentId && parseInt(product.parentProductId) !== parentId) {
                        cat[productId] = { ...product, quantity: kitQuantity };
                    }
                });

                if (Object.keys(cat).length > 0) {
                    newTempCart[name] = cat;
                }
            });

            updateTempCart();

            _.each(newTempCart, (cartItem, category) => {
                const obj = {};
                obj[category] = cartItem;

                updateTempCart(obj);
            });

        } else {
            $element.addClass("active");

            // actual temp cart
            if (parentProduct.name !== "None") {
                if (filter === "Charging Accessories") {
                    updateTempCart({ ["ChargingAccessory-" + parentProduct.id]: { [parentProduct.id]: { ...parentProduct, quantity: kitQuantity } } });
                } else if (filter === "Optional Accessories") {
                    updateTempCart({ ["OptionalAccessory-" + parentProduct.id]: { [parentProduct.id]: { ...parentProduct, quantity: kitQuantity } } });
                }
            }

            // UI temp cart
            _.each(products, product => {
                if (product.name !== "None") {
                    let qty = kitQuantity;
                    let dummyQty = 1;
                    let test = [product.parentProductId];

                    if (filter === "Charging Accessories") {
                        if (tempCartKitUI[`ChargingAccessory-${product.id}`]) {
                            dummyQty += tempCartKitUI[`ChargingAccessory-${product.id}`][product.id].dummyQuantity;
                            qty = tempCartKitUI[`ChargingAccessory-${product.id}`][product.id].quantity + kitQuantity;

                            test = [...tempCartKitUI[`ChargingAccessory-${product.id}`][product.id].parentProductIds, product.parentProductId];
                        }

                        updateTempCartKitUI({ ["ChargingAccessory-" + product.id]: { [product.id]: { ...product, parentProductIds: test, quantity: qty, dummyQuantity: dummyQty } } });
                    } else if (filter === "Optional Accessories") {
                        if (tempCartKitUI[`OptionalAccessory-${product.id}`]) {
                            dummyQty += tempCartKitUI[`OptionalAccessory-${product.id}`][product.id].dummyQuantity;
                            qty = tempCartKitUI[`OptionalAccessory-${product.id}`][product.id].quantity + kitQuantity;

                            test = [...tempCartKitUI[`OptionalAccessory-${product.id}`][product.id].parentProductIds, product.parentProductId];
                        }

                        updateTempCartKitUI({ ["OptionalAccessory-" + product.id]: { [product.id]: { ...product, parentProductIds: test, quantity: qty, dummyQuantity: dummyQty } } });
                    }
                }
            })
        }

        this.checkActive();
    }

    checkActive() {
        const { wizards } = this.props;

        if ($("input[id^=\"checkbox-\"]").hasClass("active")) {
            $("#nextButton, #topNextButton").removeClass("disabled");
        } else if (wizards.KitsBuild.currentStep !== 4) {
            $("#nextButton, #topNextButton").addClass("disabled");
        }
    }

    updateCheckboxes(tempCart) {
        const selectedProductIds = [];
        _.each(tempCart, (category) => {
            _.each(category, (product) => {
                selectedProductIds.push(parseInt(product.id));
            });
        });

        const elements = document.querySelectorAll("input[id^=\"checkbox-\"]");

        _.each(elements, element => {
            let elementId = parseInt(element.dataset.productId);
            if (selectedProductIds.includes(elementId)) {
                element.checked = true;
                element.className = "checkbox active";
                $("#nextButton, #topNextButton").removeClass("disabled");
            }
        });
    }

    nextOnClick() {
        // This is in the next button listener
        const { wizards, goNext, onFinish } = this.props;
        const { totalSteps, currentStep } = wizards.KitsBuild;

        // Wizard is finished at the second to last step because the last step is the Cart
        if (currentStep === totalSteps) {
            onFinish("KitsBuild");
        } else {
            goNext("KitsBuild");
        }

        window.scrollTo(0, 0);
    }

    previousOnClick() {
        const { goPrev } = this.props;
        goPrev("KitsBuild");
        window.scrollTo(0, 0);
    }

    orderSummaryClick() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    renderAccessories() {
        // Accessories for build kit, driven by product attributes in the admin. 4 category types with values with associated products.
        const { filter, attributes } = this.props;
        // const { kitAttributes } = this.state;

        return _.map(attributes, attribute =>
            <div key={attribute.productAttributeId} className="charging-container">
                <div className="row">
                    <div className="col-md-12">
                        {attribute.name &&
                        <h3>{attribute.name}</h3>
                        }
                    </div>
                </div>
                <div className="masonry">
                    <div className="masonry__container row masonry--active">
                        {_.map(attribute.values, value => {
                            const product = value.product;
                            let productsArray = [];

                            if (product) {
                                if (filter === "Charging Accessories") {
                                    product.parentCategory = "Charging Accessories";
                                    productsArray.push(product);
                                } else if (filter === "Optional Accessories") {
                                    product.parentCategory = "Optional Accessories";
                                    productsArray.push(product);
                                }

                                return (
                                    <div key={value.id} className="masonry__item col-md-6 kit-accessory">

                                        <h5 className="accessory-item-title">{product.name}</h5>
                                        <div className="accessory-sku-title">{product.sku}</div>

                                        <div className="row accessory-row">
                                            <div className="col-4">
                                                {product.defaultPictureModel &&
                                                    <img alt="Image" src={product.defaultPictureModel.fullSizeImageUrl} />
                                                }
                                            </div>
                                            <div className="col-8 accessory-desc">
                                                {product.fullDescription ?
                                                    <div className="row accessory-product-desc" dangerouslySetInnerHTML={{ __html: product.fullDescription }}/>
                                                    :
                                                    <div>
                                                        <div className="row accessory-product-desc" >{product.shortDescription}</div>
                                                        {product.sku &&
                                                            <div className="row accessory-product-part-number"><span className="part-number"><Translate value="misc.partNumber" />:</span> {product.sku}</div>
                                                        }
                                                    </div>
                                                }

                                                <div className="row total-price-row">
                                                    <div className="accessory-total-price">{product.productPrice.price}</div>
                                                </div>

                                                <div className="row accessory-checkbox">
                                                    <div className="check-box-column">
                                                        <form>
                                                            <div className="input-checkbox">
                                                                <input className="checkbox" id={`checkbox-${value.product.id}`} type="checkbox" name="select" data-product-id={value.product.id} onClick={ () => this.boxChecked(product, productsArray, product.id)} />
                                                                <label htmlFor={`checkbox-${value.product.id}`}/>
                                                            </div>
                                                            <span className="checkbox-text"><Translate value="misc.selectForKit" /></span>
                                                        </form>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div>
            </div>
        )
    }

    renderMessage() {
        const { filter } = this.props;

        if (filter === "Charging Accessories") {
            return (
                <p className="highlighted-message"><Translate value="buildAKit.chargingAccessories.message" /></p>
            )
        } else if (filter === "Optional Accessories") {
            return (
                <p className="highlighted-message"><Translate value="buildAKit.optionalAccessories.message" /></p>
            )
        } else {
            return null;
        }

    }

    render() {
        const { wizards } = this.props;

        return (
            <div className="accessories-wizard">
                <div className="build-kit-wizard-message">
                    <div className="row">
                        <div className="col-md-12">
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>

                <section className="actions clearfix kit-accessories-buttons kit-accessories-button-top">
                    <ul role="menu" aria-label="Pagination">
                        <li className="" aria-disabled="false">
                            <button type="button" onClick={ () => this.previousOnClick()}><Translate value="misc.previous" /></button>
                        </li>
                        <li id="topNextButton" className="disabled" aria-hidden="false" aria-disabled="true">
                            <button type="submit" onClick={ wizards.KitsBuild.currentStep !== 4 ? () => this.nextOnClick() : this.orderSummaryClick}><Translate value={wizards.KitsBuild.currentStep !== 4 ? "misc.next" : "orderSummary.title"} /></button>
                        </li>
                    </ul>
                </section>

                <div className="kit-accessories-container">
                    {this.renderAccessories()}
                </div>

                <section className="actions clearfix kit-accessories-buttons kit-accessories-button-bottom">
                    <ul role="menu" aria-label="Pagination">
                        <li className="" aria-disabled="false">
                            <button type="button" onClick={ () => this.previousOnClick()}><Translate value="misc.previous" /></button>
                        </li>
                        <li id="nextButton" className="disabled" aria-hidden="false" aria-disabled="true">
                            <button type="submit" onClick={ wizards.KitsBuild.currentStep !== 4 ? () => this.nextOnClick() : this.orderSummaryClick}><Translate value={wizards.KitsBuild.currentStep !== 4 ? "misc.next" : "orderSummary.title"} /></button>
                        </li>
                    </ul>
                </section>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        selectedProduct: state.selectedProduct,
        tempCart: state.tempCart,
        tempCartKitUI: state.tempCartKitUI
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addToNopCommerceCart: addToNopCommerceCart,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI,
        goNext: goNext,
        goPrev: goPrev,
        onFinish: onFinish
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(KitAccessories);